<template>
  <div>
    <div class="box">
      <img @click="backOff()" style="width:19px;height:auto;" src="../../img/首页导航/33.png" alt="">
      <div style="display: flex;justify-content: center;align-items: center;">
        <img style="width: 43px;height:23px;" src="../../img/首页/子拓logo@3x.png" alt="">
        <span style="font-size: 17px;color:#ffffff;padding-left:6px;">子拓国际贸易</span>
      </div>
      <p style="position: absolute;right: 45px;color: #ffff;font-size: x-small;">
          <span style="display: conten;" v-show="typefaces == 2" @click="typeface(1)">中文版</span>
          <span style="display: conten;" v-show="typefaces == 1" @click="typeface(2)">English</span>
      </p>
      <img class="bann_img" style="width:20px;height:18px;" @mouseover="logoFlant=true" @mouseleave="logoFlant=false"
           src="../../img/首页/公众号@3x.png" alt="">
      <transition name="fade">
        <div class="img_img" style="position:absolute;top:40px;right:0;z-index:999;" v-if="logoFlant">
          <img style="width:80px;height:80px;" src="../..//img/子拓公众号.jpg" alt="">
        </div>
      </transition>
    </div>

    <section>
      <div class="nav">
        <div class="lis" v-for="(item, i) in headerText" :key="i">
          <div class="lis_p" @click="buttonIpt(i)">
            <p @click="jump(item)">{{typefaces == 1 ? item.name : item.names}}</p>
            <img v-if="item.data.length!=0" class="btn_img" :src="navIndexs==i?logoBanner[1]:logoBanner[0]" alt="">
          </div>
          <div v-if="navIndexs == i">
            <ul v-for="(val, index) in item.data" :key="index">
              <li @click="jumps(val)">{{val.name}}</li>
            </ul>
          </div>
        </div>
      </div>
    </section>


  </div>
</template>

<script>

  export default {
    name: 'Jump',
    data() {
      return {
        typefaces: 1,
        logoFlant: false,
        headerText: [
          {
            name: '首页',
            names: 'Home',
            router: '/',
            data: [],
            datas: []
          }, {
            name: '公司简介',
            names: 'Corporate Introduction',
            router: '/companyProfile',
            data: [],
            datas: []
            // data: [{name: '公司简介', router: '/companyProfile'},
            //        {name: '发展历程', router: '/History'},
            //        {name: '企业理念', router: '/Enterprise'},
            //        {name: '荣誉业绩', router: '/Honorary'}],
            // datas: ['Company Introduction','Development History','Company Vision','Awards']
          }, {
            name: '公司新闻',
            names: 'Corporate News',
            router: '/CompanyNews',
            data: [],
            // data: ['', '', ''],
            // data: [{name: '公司新闻', router: '/CompanyNews'},
            //        {name: '媒体聚焦', router: '/MediaFocus'},
            //        {name: '企业刊物', router: '/HouseOrgan'}],
            datas: ['Company News', 'Media focus', 'House Organ']
          }, {
            name: '项目介绍',
            names: 'Project Introduction',
            router: '/CoalTrade',
            data: [],
            // data: [{name: '煤炭贸易', router: '/CoalTrade'},
            //        {name: '境外物流', router: '/Overseas'},
            //        {name: '境内物流', router: '/Domestic'},
            //        {name: '仓储服务', router: '/Warehousing'}],
            datas: ['Coal Trade', 'Overseas Logistics', 'Domestic logistics', 'Warehousing Services']
          }, {
            name: '业务范围',
            names: 'Business',
            router: '/Ganqimaodu',
            data: [],
            // data: [{name: '甘其毛都口岸', router: '/Ganqimaodu'},
            //        {name: '满都拉口岸', router: '/Mandula'},
            //        {name: '二连浩特口岸', router: '/Erenhot'},
            //        {name: '海煤业务', router: '/Seaborne'},
            //        {name: '乌拉特中旗', router: '/Middle'}],
            datas: ['The Ganqimaodu Port', 'The Mandula Port', 'The Erenhot Port', 'Seaborne trade', 'The Urad Middle Banner']
          }, {
            name: '行业资讯',
            names: 'Industry News',
            router: '/Industry',
            data: [],
            datas: []
          }, {
            name: '联系我们',
            names: 'Contact Us',
            router: '/ContactUs',
            data: [],
            // data: [{name: '联系我们', router: '/ContactUs'},
            //        {name: '发展历程', router: '/History'},
            //        {name: '企业理念', router: '/Enterprise'},
            //        {name: '人才招聘', router: '/Talents'},
            //        {name: '荣誉业绩', router: '/Honorary'}],
            datas: ['Contact Us', 'Development History', 'Business Culture', 'Talents', 'Awards']
          }
        ],
        navIndexs: 0,
        logoBanner: [require('../../img/首页导航/11.png'), require('../../img/首页导航/22.png')],
      }
    },
    computed: {
      aaa() {
        return this.$root.TYPEFACE;
      }
    },
    watch: {
      aaa(type) {
          this.typefaces = type;
      }
    },

    mounted() {
        this.typefaces = (this.$root.TYPEFACE == undefined ? this.typefaces : this.$root.TYPEFACE);
    },


    methods: {

      typeface(type){
        this.$root.TYPEFACE = type;
        this.typefaces = type;
      },

      // 后退
      backOff() {
        this.$router.go(-1);
      },

      buttonIpt(i) {
        let index = this.navIndexs;
        if (index == i) {
          this.navIndexs = 0;
        } else {
          this.navIndexs = i;
        }
      },

      jump(item) {
        if (item.name == '首页' || item.name == '行业资讯'|| item.name == '公司简介'|| item.name == '公司新闻'
          || item.name == '项目介绍'|| item.name == '业务范围'|| item.name == '联系我们') {
          this.$router.push(item.router);
        }

      },

      jumps(val) {
        this.$router.push(val.router);
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  html, body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
  }

  p, ul, li {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .box {
    display: flex;
    background-color: #BB1E10;
    height: 49px;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    position: relative;
  }

  section {
    flex: 1;
    overflow-y: scroll;
  }

  .nav {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .lis {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .lis_p {
    display: flex;
    padding: 15px 20px;
    border-bottom: 1px solid #D6D6D6;
    justify-content: space-between;
    align-items: center;
  }

  .lis_p p {
    font-size: 16px;
  }

  .lis_p img {
    width: 13px;
    height: 13px;
  }

  ul li {
    font-size: 15px;
    padding: 15px 40px;
    border-bottom: 1px solid #D6D6D6;
    background: #F7F7F7;
    color: #747474;
  }

  .tap_red {
    color: #BB1E10;
  }

  a {
    text-decoration: none;
  }

</style>



// WEBPACK FOOTER //
// src/components/Jump.vue